import "../assets/styles/components/pills-loader.scss";

export default function PillsLoader() {
  return (
    <div className="pills-loader position-fixed w-100 h-100 top-0 start-0 d-flex justify-content-center align-items-center">
      <span className="pills-loader__loader position-relative"></span>
    </div>
  );
}
